/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelZoneSuperRegion.ts               *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/general/zone-super-region";

export class AutogenModelZoneSuperRegion<RowType extends ModelRow> extends Endpoint<RowType, RowZoneSuperRegionFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowZoneSuperRegion extends ModelRow<RowZoneSuperRegionFields> {
	constructor(values?: Partial<RowZoneSuperRegionFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowZoneSuperRegionFields {
	company_id: string;
	descr: string;
	id: string;
}

